import { createTypes } from "redux-create-types";
import { ajaxJson } from "imports/ajax";
import { libraryDocumentActionsCreators } from "db/library-document/libraryDocument.action";
import { libraryVideoActionsCreators } from "db/library-video/libraryVideo.action";
import {
    map2LibraryDocumentObj,
    map2LibraryVideoObj,
    map2CourseObj
} from "imports/mapper";
import { courseActionCreators } from "db/course/course.action";

const namespace = "page-courseLibrary";

export const libraryActions = createTypes(
    ["toggleSpinner", "setError", "setDocumentIds", "setVideoIds"],
    namespace
);

function setDocumentIds(ids) {
    return dispatch => {
        dispatch({
            type: libraryActions.setDocumentIds,
            payload: ids
        });
    };
}

function setVideoIds(ids) {
    return dispatch => {
        dispatch({
            type: libraryActions.setVideoIds,
            payload: ids
        });
    };
}

function showSpinner(apiName) {
    return dispatch => {
        dispatch({
            type: libraryActions.toggleSpinner,
            payload: true,
            meta: { apiName }
        });
    };
}

function hideSpinner(apiName) {
    return dispatch => {
        dispatch({
            type: libraryActions.toggleSpinner,
            payload: false,
            meta: { apiName }
        });
    };
}

function getCourseApiFail(err) {
    return dispatch => {
        dispatch({
            type: libraryActions.setError,
            payload: err,
            meta: { apiName: "course" }
        });
    };
}

function getCourseApiSuccess(res) {
    return dispatch => {
        const courseObj = map2CourseObj(res.data);
        dispatch(courseActionCreators.save(courseObj));
    };
}

export function getCourseFromApi(courseId) {
    return dispatch => {
        dispatch(showSpinner("course"));
        return ajaxJson
            .get(`/courses/${courseId}`)
            .then(
                res => dispatch(getCourseApiSuccess(res)),
                err => dispatch(getCourseApiFail(err))
            )
            .then(() => {
                dispatch(hideSpinner("course"));
            });
    };
}

function getDocumentApiSuccess(res, courseId) {
    return dispatch => {
        let listOfDocuments = res.data["results"].map(item => {
            return map2LibraryDocumentObj(item);
        });

        listOfDocuments.forEach(item => {
            dispatch(libraryDocumentActionsCreators.save(item, courseId));
        });

        listOfDocuments = listOfDocuments.map(item => item.id);
        dispatch(setDocumentIds(listOfDocuments));
    };
}

function getDocumentApiFail(err) {
    return dispatch => {
        dispatch({
            type: libraryActions.setError,
            payload: err,
            meta: { apiName: "document" }
        });
    };
}

export function getDocumentFromApi(programId, courseId) {
    return dispatch => {
        dispatch(showSpinner("document"));
        return ajaxJson
            .get(`/programs/${programId}/courses/${courseId}/library_documents`)
            .then(
                res => dispatch(getDocumentApiSuccess(res, courseId)),
                err => dispatch(getDocumentApiFail(err))
            )
            .then(() => {
                dispatch(hideSpinner("document"));
            });
    };
}

function getVideosApiSuccess(res, courseId) {
    return dispatch => {
        let listOfVideos = res.data["results"].map(item => {
            return map2LibraryVideoObj(item);
        });

        listOfVideos.forEach(item => {
            dispatch(libraryVideoActionsCreators.save(item, courseId));
        });

        listOfVideos = listOfVideos.map(item => item.id);
        dispatch(setVideoIds(listOfVideos));
    };
}

function getVideosApiFail(err) {
    return dispatch => {
        dispatch({
            type: libraryActions.setError,
            payload: err,
            meta: { apiName: "video" }
        });
    };
}

export function getVideoFromApi(programId, courseId) {
    return dispatch => {
        dispatch(showSpinner("video"));
        return ajaxJson
            .get(`/programs/${programId}/courses/${courseId}/library_videos`)
            .then(
                res => dispatch(getVideosApiSuccess(res, courseId)),
                err => dispatch(getVideosApiFail(err))
            )
            .then(() => {
                dispatch(hideSpinner("video"));
            });
    };
}
